export default "__VITE_ASSET__DwciPK$Y__"